export default __webpack_public_path__ + "static/media/BBL.e9cc93c9.png";